// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file message/message_system_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { CallFinishReason } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';

/**
 * Describes the file message/message_system_model.proto.
 */
export const file_message_message_system_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_common_common_model]
  );

/**
 * @generated from message com.gem.bff.contract.SystemMessage
 */
export type SystemMessage = Message<'com.gem.bff.contract.SystemMessage'> & {
  /**
   * @generated from oneof com.gem.bff.contract.SystemMessage.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.CallPayload call = 1;
         */
        value: SystemMessage_CallPayload;
        case: 'call';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload chatTypeChanged = 2;
         */
        value: SystemMessage_ChatTypeChangedPayload;
        case: 'chatTypeChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatAdminsAddedPayload chatAdminsAdded = 3;
         */
        value: SystemMessage_ChatAdminsAddedPayload;
        case: 'chatAdminsAdded';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatAdminsRemovedPayload chatAdminsRemoved = 4;
         */
        value: SystemMessage_ChatAdminsRemovedPayload;
        case: 'chatAdminsRemoved';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatJoinedPayload chatJoined = 5;
         */
        value: SystemMessage_ChatJoinedPayload;
        case: 'chatJoined';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatLeftPayload chatLeft = 6;
         */
        value: SystemMessage_ChatLeftPayload;
        case: 'chatLeft';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatPinnedMessagePayload chatPinnedMessage = 7;
         */
        value: SystemMessage_ChatPinnedMessagePayload;
        case: 'chatPinnedMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatOwnerChangedPayload chatOwnerChanged = 8;
         */
        value: SystemMessage_ChatOwnerChangedPayload;
        case: 'chatOwnerChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatAddedPayload chatAdded = 9;
         */
        value: SystemMessage_ChatAddedPayload;
        case: 'chatAdded';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage.ChatTtlChangedPayload chatTtlChanged = 10;
         */
        value: SystemMessage_ChatTtlChangedPayload;
        case: 'chatTtlChanged';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.SystemMessage.
 * Use `create(SystemMessageSchema)` to create a new message.
 */
export const SystemMessageSchema: GenMessage<SystemMessage> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.CallPayload
 */
export type SystemMessage_CallPayload =
  Message<'com.gem.bff.contract.SystemMessage.CallPayload'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: optional string initiatorNickname = 2;
     */
    initiatorNickname?: string;

    /**
     * @generated from field: string channelId = 3;
     */
    channelId: string;

    /**
     * @generated from field: int64 startTs = 5;
     */
    startTs: bigint;

    /**
     * @generated from field: optional int64 finishTs = 6;
     */
    finishTs?: bigint;

    /**
     * @generated from field: optional int64 duration = 7;
     */
    duration?: bigint;

    /**
     * @generated from field: optional com.gem.bff.contract.CallFinishReason finishReason = 8;
     */
    finishReason?: CallFinishReason;

    /**
     * @generated from field: optional int64 finishInitiatorId = 9;
     */
    finishInitiatorId?: bigint;

    /**
     * @generated from field: optional string finishInitiatorNickname = 10;
     */
    finishInitiatorNickname?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.CallPayload.
 * Use `create(SystemMessage_CallPayloadSchema)` to create a new message.
 */
export const SystemMessage_CallPayloadSchema: GenMessage<SystemMessage_CallPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 0);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload
 */
export type SystemMessage_ChatTypeChangedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.SystemMessagePayload payload = 1;
     */
    payload?: SystemMessage_SystemMessagePayload;

    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload.Type newType = 2;
     */
    newType: SystemMessage_ChatTypeChangedPayload_Type;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload.
 * Use `create(SystemMessage_ChatTypeChangedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatTypeChangedPayloadSchema: GenMessage<SystemMessage_ChatTypeChangedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 1);

/**
 * @generated from enum com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload.Type
 */
export enum SystemMessage_ChatTypeChangedPayload_Type {
  /**
   * @generated from enum value: CLOSED_CHANNEL = 0;
   */
  CLOSED_CHANNEL = 0,

  /**
   * @generated from enum value: OPEN_CHANNEL = 1;
   */
  OPEN_CHANNEL = 1,
}

/**
 * Describes the enum com.gem.bff.contract.SystemMessage.ChatTypeChangedPayload.Type.
 */
export const SystemMessage_ChatTypeChangedPayload_TypeSchema: GenEnum<SystemMessage_ChatTypeChangedPayload_Type> =
  /*@__PURE__*/
  enumDesc(file_message_message_system_model, 0, 1, 0);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatAdminsAddedPayload
 */
export type SystemMessage_ChatAdminsAddedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatAdminsAddedPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.UsersChangedPayload payload = 1;
     */
    payload?: SystemMessage_UsersChangedPayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatAdminsAddedPayload.
 * Use `create(SystemMessage_ChatAdminsAddedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatAdminsAddedPayloadSchema: GenMessage<SystemMessage_ChatAdminsAddedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 2);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatAdminsRemovedPayload
 */
export type SystemMessage_ChatAdminsRemovedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatAdminsRemovedPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.UsersChangedByPayload payload = 1;
     */
    payload?: SystemMessage_UsersChangedByPayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatAdminsRemovedPayload.
 * Use `create(SystemMessage_ChatAdminsRemovedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatAdminsRemovedPayloadSchema: GenMessage<SystemMessage_ChatAdminsRemovedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 3);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatJoinedPayload
 */
export type SystemMessage_ChatJoinedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatJoinedPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.UsersChangedPayload payload = 1;
     */
    payload?: SystemMessage_UsersChangedPayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatJoinedPayload.
 * Use `create(SystemMessage_ChatJoinedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatJoinedPayloadSchema: GenMessage<SystemMessage_ChatJoinedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 4);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatLeftPayload
 */
export type SystemMessage_ChatLeftPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatLeftPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.SystemMessagePayload payload = 1;
     */
    payload?: SystemMessage_SystemMessagePayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatLeftPayload.
 * Use `create(SystemMessage_ChatLeftPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatLeftPayloadSchema: GenMessage<SystemMessage_ChatLeftPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 5);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatPinnedMessagePayload
 */
export type SystemMessage_ChatPinnedMessagePayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatPinnedMessagePayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.SystemMessagePayload payload = 1;
     */
    payload?: SystemMessage_SystemMessagePayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatPinnedMessagePayload.
 * Use `create(SystemMessage_ChatPinnedMessagePayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatPinnedMessagePayloadSchema: GenMessage<SystemMessage_ChatPinnedMessagePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 6);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatOwnerChangedPayload
 */
export type SystemMessage_ChatOwnerChangedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatOwnerChangedPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.UsersChangedByPayload payload = 1;
     */
    payload?: SystemMessage_UsersChangedByPayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatOwnerChangedPayload.
 * Use `create(SystemMessage_ChatOwnerChangedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatOwnerChangedPayloadSchema: GenMessage<SystemMessage_ChatOwnerChangedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 7);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatAddedPayload
 */
export type SystemMessage_ChatAddedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatAddedPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.SystemMessage.UsersChangedByPayload payload = 1;
     */
    payload?: SystemMessage_UsersChangedByPayload;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatAddedPayload.
 * Use `create(SystemMessage_ChatAddedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatAddedPayloadSchema: GenMessage<SystemMessage_ChatAddedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 8);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.SystemMessagePayload
 */
export type SystemMessage_SystemMessagePayload =
  Message<'com.gem.bff.contract.SystemMessage.SystemMessagePayload'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: optional string initiatorNickname = 2;
     */
    initiatorNickname?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.SystemMessagePayload.
 * Use `create(SystemMessage_SystemMessagePayloadSchema)` to create a new message.
 */
export const SystemMessage_SystemMessagePayloadSchema: GenMessage<SystemMessage_SystemMessagePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 9);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.UsersChangedByPayload
 */
export type SystemMessage_UsersChangedByPayload =
  Message<'com.gem.bff.contract.SystemMessage.UsersChangedByPayload'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: optional string initiatorNickname = 2;
     */
    initiatorNickname?: string;

    /**
     * @generated from field: repeated com.gem.bff.contract.SystemMessage.UserWithDisplayedName users = 3;
     */
    users: SystemMessage_UserWithDisplayedName[];
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.UsersChangedByPayload.
 * Use `create(SystemMessage_UsersChangedByPayloadSchema)` to create a new message.
 */
export const SystemMessage_UsersChangedByPayloadSchema: GenMessage<SystemMessage_UsersChangedByPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 10);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.UsersChangedPayload
 */
export type SystemMessage_UsersChangedPayload =
  Message<'com.gem.bff.contract.SystemMessage.UsersChangedPayload'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.SystemMessage.UserWithDisplayedName users = 1;
     */
    users: SystemMessage_UserWithDisplayedName[];
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.UsersChangedPayload.
 * Use `create(SystemMessage_UsersChangedPayloadSchema)` to create a new message.
 */
export const SystemMessage_UsersChangedPayloadSchema: GenMessage<SystemMessage_UsersChangedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 11);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.UserWithDisplayedName
 */
export type SystemMessage_UserWithDisplayedName =
  Message<'com.gem.bff.contract.SystemMessage.UserWithDisplayedName'> & {
    /**
     * @generated from field: int64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string displayedName = 2;
     */
    displayedName: string;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.UserWithDisplayedName.
 * Use `create(SystemMessage_UserWithDisplayedNameSchema)` to create a new message.
 */
export const SystemMessage_UserWithDisplayedNameSchema: GenMessage<SystemMessage_UserWithDisplayedName> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 12);

/**
 * @generated from message com.gem.bff.contract.SystemMessage.ChatTtlChangedPayload
 */
export type SystemMessage_ChatTtlChangedPayload =
  Message<'com.gem.bff.contract.SystemMessage.ChatTtlChangedPayload'> & {
    /**
     * @generated from field: int64 initiatorId = 1;
     */
    initiatorId: bigint;

    /**
     * @generated from field: optional string initiatorNickname = 2;
     */
    initiatorNickname?: string;

    /**
     * @generated from field: optional int64 periodMs = 3;
     */
    periodMs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.SystemMessage.ChatTtlChangedPayload.
 * Use `create(SystemMessage_ChatTtlChangedPayloadSchema)` to create a new message.
 */
export const SystemMessage_ChatTtlChangedPayloadSchema: GenMessage<SystemMessage_ChatTtlChangedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_system_model, 0, 13);
